import type { Action, GameRuleState, WSRequest } from "whole-shared";
import { GameRule } from "whole-shared";

import { ws } from "../../ws";
import { diceRoller } from "../globals";
import { hud } from "../hud";

export const sendAction = (action: WSRequest["action"]) => () => {
  hud.enable(false);
  ws.request({ action });
};

export abstract class ClientGameRule<T extends GameRuleState = GameRuleState> extends GameRule<false, T> {
  async action(playerId: number, action: Action) {
    const { round, turn, victoryPoints } = this.state;

    hud.round(round);
    hud.turn(turn);
    hud.victoryPoints(victoryPoints);

    return super.action(playerId, action);
  }

  async rollOff(playerId: number, _action: Action) {
    const result = this.rollOffResult();

    if(! result) return result;

    const { rollOff, rolls } = this.state;
    const faces = rolls.length ? rolls : [6, 6];
    const player = playerId === this.player1Id ? 1 : playerId === this.player2Id ? 2 : 0;
    const [tie, description, nextDesc, face1, face2] = rollOff[0]
      ? rollOff[1]
        ? [true, "Tie! Commanders have to re-roll", player === 1 ? "Commander 2 has to roll" : "Commander 1 has to roll", faces[0], faces[1]]
        : ([false, "Commander 2 has to roll", "", true, faces[1]] as const)
      : rollOff[1]
        ? ([false, "Commander 1 has to roll", "", faces[0], true] as const)
        : [false, "Commanders have to roll", "", faces[0], faces[1]];

    if(result === -1 && ! tie) diceRoller.setState({ double: true, rolls: [face1, face2] });
    else {
      await new Promise<void>(resolve => {
        const state = diceRoller.getState();
        const [action, faces] =
          state.hidden || (state.rolls[0] === true && state.rolls[1] === true)
            ? [resolve, rolls as [number, number]]
            : [() => diceRoller.setState({ action: resolve, double: true, rolls: rolls as [number, number] }), [true, true] as [true, true]];

        diceRoller.setState({ action, double: true, rolls: faces });
      });
    }

    if(result !== -1) return result;

    hud.description(description);

    const roll = player && (! rollOff[player - 1] || tie);
    const roller = () => {
      hud.description(nextDesc);
      diceRoller.setState({ action: sendAction({ roll: true }), double: true, rolls: player === 1 ? [true, face2] : [face1, true] });
    };

    if(player && roll) {
      hud.reset();
      hud.addChoice("Roll", roller);
    }

    return result;
  }
}
